import { notification } from "antd";
import { globalAppConfig } from "../../config";
import Helper from "../../Helper";

export const shareValuesConstructor = (
    invitee: string | null,
    shareItemType: "location" | "project" | "delivery" | "equipment",
    shareItemId: number
) => {
    const values: { [key: string]: any } = {
        invitee: invitee,
    };

    if (shareItemType === "location" && shareItemId) {
        values["area"] = shareItemId;
    }

    if (shareItemType === "equipment" && shareItemId) {
        values["equipment"] = shareItemId;
    }

    if (shareItemType === "delivery" && shareItemId) {
        values["delivery"] = shareItemId;
    }

    // No additional values needed for project sharing

    return JSON.stringify({
        values,
    });
};

export const shareProjectItem = async (
    teamSubdomain: string,
    projectToken: string,
    invitee: string | null,
    shareItemType: "location" | "project" | "delivery" | "equipment",
    shareItemId: number
) => {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/share`;
    const options = {
        method: "post",
        body: shareValuesConstructor(invitee, shareItemType, shareItemId),
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                notification.success({
                    message: `Shared ${shareItemType.charAt(0).toUpperCase()}${shareItemType.slice(1)}`,
                    description: `${shareItemType.charAt(0).toUpperCase()}${shareItemType.slice(1)} has been shared.`,
                });

                return response.json();
            }
        })
        .catch((err) => {
            notification.error({
                message: `Failed to Share ${shareItemType.charAt(0).toUpperCase()}${shareItemType.slice(1)}`,
                description: `The ${shareItemType.charAt(0).toUpperCase()}${shareItemType.slice(1)} could not be shared: ${err}`,
                duration: globalAppConfig.NOTIFICATION_DURATION,
            });
        });
};
